import {
    Box,
    Button,
    Checkbox,
    Flex,
    HStack,
    Text,
    VStack,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import usePathNavigate from "../lib/hook/usePathNavigate";
import { useLocation } from "react-router-dom";
import { useRecoilState } from "recoil";
import { isDevState } from "../lib/atoms/companyState";
import { PaymentInfoModel } from "./api/type";
import { digit } from "../lib/util/digit";
import { PaymentStatus } from "../lib/api/enum";

export const getPGType = (dev: boolean) => {
    if (dev) {
        return "html5_inicis.INIpayTest";
    } else {
        return "html5_inicis.MOIminth69";
    }
};

const PaymentsSMS = () => {
    // dev: dev-
    const [isDev, setIsDev] = useRecoilState(isDevState);

    const { pathNavigate, backNavigate } = usePathNavigate();
    const location = useLocation();

    const paymentInfo = { ...location.state } as PaymentInfoModel;
    console.log("PaymentsSMS : ", paymentInfo);
    const [loaded, setLoaded] = useState(false);

    const [card, setCard] = useState<boolean>(true);

    const [checkedAgree, setCheckedAgree] = useState([false, false]);
    const allChecked = checkedAgree.every(Boolean);

    /* 가맹점 식별코드 */
    const userCode: string = "imp32970589";
    // const pg: string = getPGType(isDev);

    const onPayment = () => {
        /* 결제 데이터 */
        const data = {
            // pg: pg,
            channelKey: isDev
                ? "channel-key-139d03d0-fb87-4b68-9b46-63b4f221bc62"
                : "channel-key-4ea25f98-1009-49ad-85d0-9e6d27b7be48",
            pay_method: card ? "card" : "trans",
            merchant_uid: paymentInfo.merchant_uid,
            name: "민트하우스",
            amount: paymentInfo.payment_amount,
            buyer_email: "",
            buyer_name: paymentInfo.payer_name,
            buyer_tel: paymentInfo.payer_phone_num,
            buyer_addr: "",
            buyer_postcode: "",
            m_redirect_url: `${window.location.origin}/oemrequestpay/completed`,
        };

        const { IMP } = window;
        IMP.init(userCode);
        IMP.request_pay(data, function (response: any) {
            //결제 후 호출되는 callback함수
            console.log("request_pay response: ", response);

            const { imp_uid, merchant_uid, error_code, error_msg } = response;
            if (response.success == false) {
                alert(
                    `결제에 실패하였습니다. 에러 내용: ${response.error_msg}`
                );
                return;
            }

            pathNavigate(
                `/oemrequestpay/completed?web=${true}&merchant_uid=${merchant_uid}&imp_uid=${imp_uid}&imp_success=${
                    response.success
                }&error_msg=${error_msg}&error_code=${error_code}`
            );
        });
    };

    const onSelectCard = (select: boolean) => {
        setCard(select);
    };

    useEffect(() => {
        if (paymentInfo.payment_status === PaymentStatus.REQUEST) {
            setLoaded(true);
        } else {
            pathNavigate("/oemrequestpay/expiration");
        }
    }, []);

    return loaded ? (
        <Box display={"flex"} flexDirection={"column"} h={"100%"}>
            <Box p={"20px"}>
                <Text
                    w="100%"
                    h="20px"
                    fontSize="16px"
                    fontWeight={"semibold"}
                    mb={"10px"}
                >
                    접수내역 및 금액
                </Text>
                <Flex justifyContent="space-between" mb={"5px"}>
                    <Text
                        fontSize="14px"
                        fontWeight={"medium"}
                        color={"#757575"}
                    >
                        접수번호
                    </Text>
                    <Text
                        fontSize="14px"
                        fontWeight={"medium"}
                        color={"#212121"}
                    >
                        {paymentInfo.receipt_code}
                    </Text>
                </Flex>

                <Flex justifyContent="space-between" mb={"5px"}>
                    <Text
                        fontSize="14px"
                        fontWeight={"medium"}
                        color={"#757575"}
                    >
                        접수자명
                    </Text>
                    <Text
                        fontSize="14px"
                        fontWeight={"medium"}
                        color={"#212121"}
                    >
                        {paymentInfo.payer_name}
                    </Text>
                </Flex>
                <Flex justifyContent="space-between" mb={"5px"}>
                    <Text
                        fontSize="14px"
                        fontWeight={"medium"}
                        color={"#757575"}
                    >
                        제품분류
                    </Text>
                    <Text
                        fontSize="14px"
                        fontWeight={"medium"}
                        color={"#212121"}
                    >
                        {paymentInfo.brand_name}
                    </Text>
                </Flex>
                <Flex justifyContent="space-between" mb={"5px"}>
                    <Text
                        fontSize="14px"
                        fontWeight={"medium"}
                        color={"#757575"}
                    >
                        제품명
                    </Text>
                    <Text
                        fontSize="14px"
                        fontWeight={"medium"}
                        color={"#212121"}
                    >
                        {paymentInfo.item_name}
                    </Text>
                </Flex>
                <Flex justifyContent="space-between" mb={"5px"}>
                    <Text
                        fontSize="14px"
                        fontWeight={"medium"}
                        color={"#757575"}
                    >
                        서비스 내용
                    </Text>
                    <Text
                        fontSize="14px"
                        fontWeight={"medium"}
                        color={"#212121"}
                    >
                        {paymentInfo.service_contents}
                    </Text>
                </Flex>
                <Flex justifyContent="space-between">
                    <Text
                        fontSize="14px"
                        fontWeight={"medium"}
                        color={"#757575"}
                    >
                        서비스 금액
                    </Text>
                    <Text
                        fontSize="14px"
                        fontWeight={"medium"}
                        color={"#212121"}
                    >
                        {digit(paymentInfo.payment_amount)} 원
                    </Text>
                </Flex>

                <Box w={"100%"} h={"1px"} bg={"#f5f6f8"} my={"10px"}></Box>

                <Flex justifyContent="space-between">
                    <Text fontSize="16px" fontWeight={"semibold"}>
                        결제 요청 금액
                    </Text>
                    <Text fontSize="16px" fontWeight={"semibold"}>
                        {digit(paymentInfo.payment_amount)}
                    </Text>
                </Flex>
            </Box>

            <Box w={"100%"} h={"8px"} bg={"#f5f6f8"}></Box>

            <Box p={"20px"}>
                <Text fontSize="16px" fontWeight={"semibold"}>
                    결제 수단
                </Text>

                <Flex justifyContent="space-between" mt={"16px"}>
                    <Button
                        flex={1}
                        fontSize="14px"
                        fontWeight={"semibold"}
                        mr={"5px"}
                        h={"45px"}
                        bgColor={card ? "black" : "white"}
                        color={card ? "white" : "black"}
                        border={"1px solid #eeeeee"}
                        colorScheme="black_button"
                        onClick={() => onSelectCard(true)}
                    >
                        신용카드 · 간편결제
                    </Button>
                    <Button
                        flex={1}
                        fontSize="14px"
                        fontWeight={"semibold"}
                        ml={"5px"}
                        h={"45px"}
                        bgColor={card ? "white" : "black"}
                        color={card ? "black" : "white"}
                        border={"1px solid #eeeeee"}
                        colorScheme="black_button"
                        onClick={() => onSelectCard(false)}
                    >
                        계좌이체
                    </Button>
                </Flex>
            </Box>

            <Box w={"100%"} h={"8px"} bg={"#f5f6f8"}></Box>

            <Box p={"20px"}>
                <Text fontSize="16px" fontWeight={"semibold"} mb={"17px"}>
                    결제 진행 동의
                </Text>
                <Flex>
                    <Checkbox
                        colorScheme="black_button"
                        isChecked={allChecked}
                        onChange={(e) =>
                            setCheckedAgree([
                                e.target.checked,
                                e.target.checked,
                            ])
                        }
                    ></Checkbox>
                    <Text fontSize="14px" fontWeight={"semibold"} ml={"8px"}>
                        전체 동의합니다.
                    </Text>
                </Flex>

                <Box w={"100%"} h={"1px"} bg={"#f5f6f8"} my={"13px"}></Box>

                <Flex mb={"14px"}>
                    <Checkbox
                        colorScheme="black_button"
                        isChecked={checkedAgree[0]}
                        onChange={(e) =>
                            setCheckedAgree([e.target.checked, checkedAgree[1]])
                        }
                    ></Checkbox>
                    <HStack fontSize="14px" fontWeight={"medium"} ml={"8px"}>
                        <Text>접수내역 및 결제 진행에 동의합니다. (필수)</Text>
                    </HStack>
                </Flex>
                <Flex mb={"20px"}>
                    <Checkbox
                        colorScheme="black_button"
                        isChecked={checkedAgree[1]}
                        onChange={(e) =>
                            setCheckedAgree([checkedAgree[0], e.target.checked])
                        }
                    ></Checkbox>
                    <HStack fontSize="14px" fontWeight={"medium"} ml={"8px"}>
                        <Text>만 14세 이상입니다. (필수)</Text>
                    </HStack>
                </Flex>

                <Button
                    w={"100%"}
                    h={"50px"}
                    fontSize="18px"
                    fontWeight={"medium"}
                    onClick={onPayment}
                    isDisabled={!allChecked}
                    bgColor={allChecked ? "black" : "#cfcfcf"}
                    color={checkedAgree ? "white" : "black"}
                    colorScheme="black_button"
                >
                    결제하기
                </Button>
            </Box>

            <Box
                w={"100%"}
                h={"100%"}
                bg={"#f5f6f8"}
                px={"20px"}
                pt={"36px"}
                mb={"30px"}
            >
                <Text
                    color={"#4d4d4d"}
                    fontSize={"13px"}
                    fontWeight={"bold"}
                    mb={"8px"}
                >
                    민트멤버스 주식회사
                </Text>
                <Text color={"#9e9e9e"} fontSize={"12px"} mb={"5px"}>
                    대표 : 장고든 | 개인정보보호책임자 : 유성철
                </Text>
                <Text color={"#9e9e9e"} fontSize={"12px"} mb={"5px"}>
                    주소 : 서울특별시 강남구 테헤란로84길 13 3층, 302호
                </Text>
                <Text color={"#9e9e9e"} fontSize={"12px"} mb={"5px"}>
                    사업자등록번호 : 152-81-02496
                </Text>
                <Text color={"#9e9e9e"} fontSize={"12px"} mb={"14px"}>
                    통신판매업신고 : 제 2022-서울강남-04046호
                </Text>
                <Text color={"#9e9e9e"} fontSize={"10px"}>
                    ⓒ 2022 Mint Members Co., Ltd. All rights reserved.
                </Text>
            </Box>
        </Box>
    ) : (
        <></>
    );
};

export default PaymentsSMS;
